import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Login from "./auth/Login";
import Register from "./auth/Register";
import UserDashboard from "./user/UserDashboard";
import AdminDashboard from "./admin/AdminDashboard";
import VendorDashboard from "./vendor/VendorDashboard";
import SessionExpiredModal from "./common/SessionExpiredModal";
import Navbar from "./common/Navbar";

function App() {
  const [expired, setExpired] = useState(false);

  const role = localStorage.getItem("role");
 const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const handler = () => setExpired(true);
    window.addEventListener("session-expired", handler);
    return () => window.removeEventListener("session-expired", handler);
  }, []);

  const DashboardRouter = () => {
    if (!token || !role) return <Navigate to="/" replace />;

    if (role === "ROLE_ADMIN") return <AdminDashboard />;
    if (role === "ROLE_VENDOR") return <VendorDashboard />;
    if (role === "ROLE_USER") return <UserDashboard />;

    // ❌ Unknown role → logout
    localStorage.clear();
    return <Navigate to="/" replace />;
  };

  return (
    <BrowserRouter>
      {token && <Navbar />}

      {expired && (
        <SessionExpiredModal
          onClose={() => {
            localStorage.clear();
            window.location.href = "/";
          }}
        />
      )}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<DashboardRouter />} />

        {/* Optional explicit routes */}
        <Route
          path="/admin"
          element={role === "ROLE_ADMIN" ? <AdminDashboard /> : <Navigate to="/" />}
        />
        <Route
          path="/vendor"
          element={role === "ROLE_VENDOR" ? <VendorDashboard /> : <Navigate to="/" />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
